import { render } from "./feedback-objective.vue?vue&type=template&id=6aed1454&ts=true"
import script from "./feedback-objective.vue?vue&type=script&lang=ts"
export * from "./feedback-objective.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__